<template>
    <div class="topbar text-xs-right">
        <v-menu offset-y>

            <v-btn
                    slot="activator"
                    color="primary"
                    flat
            >
                <v-icon dark>account_circle</v-icon>
                <span> {{ auth_user }}</span>
                <v-icon dark>arrow_drop_down</v-icon>
            </v-btn>

            <v-list>
                <v-list-tile v-if="this.role == 'ROLE_CUSTOMER_ADMIN' || this.role == 'ROLE_CUSTOMER_WORKER'" class="link-class" to="/customer">
                    <v-list-tile-title>Заказчик </v-list-tile-title>
                </v-list-tile>
                <v-list-tile class="link-class" to="/profile">
                    <v-list-tile-title>Профиль</v-list-tile-title>
                </v-list-tile>
                <v-list-tile v-if="this.role == 'ROLE_ADMIN'" class="link-class" to="/configuration">
                    <v-list-tile-title>Конфигурация</v-list-tile-title>
                </v-list-tile>
                <v-list-tile @click="logout">
                    <v-list-tile-title> Выйти</v-list-tile-title>
                </v-list-tile>
            </v-list>
        </v-menu>

    </div>

</template>

<script>
    import axios from 'axios'
    import localForage from 'localforage'
    export default {
        data()  {
            return{
                backUrl: null,
                token: '',
                role: '',
                auth_user: '',
            }
        },
        created () {
            this.token = localStorage.getItem('token');
            this.role = localStorage.getItem('role');
            this.backUrl = localStorage.getItem('url');
            this.auth_user = localStorage.getItem('auth_user');
        },
        methods: {
            logout(){
                axios({
                    method: 'post',
                    url: this.backUrl + '/api/system/context/destroy',
                    withCredentials: true,
                    headers:{
                        'Authorization': 'Basic ' + this.token
                    },
                })
                .then(() => {
                    localStorage.clear();
                    Event.$emit('logout');
                    this.$router.push('/login');
                    localForage.clear()
                })
                .catch(() => {
                    localStorage.clear();
                    Event.$emit('logout');
                    this.$router.push('/login');
                    localForage.clear()
                });
            },
        }
    }
</script>

<style scoped>
    .topbar{
        background: #f5f5f5;
    }
</style>
